import { CardBrand, PaymentMethod } from './common';

export enum FinancialTransactionType {
  MONTHLY_PAYMENT = 'MONTHLY_PAYMENT',
  EXPERIENCE = 'EXPERIENCE',
}

export enum FinancialStatus {
  PAID = 'PAID',
  PENDING_PAYMENT = 'PENDING_PAYMENT',
  CANCELLED = 'CANCELLED',
}

export type FinancialMonthlyPayment = {
  id: string;
  created_at: string;
  updated_at: string;
  subscriber_id: string;
  subscriber_name: string;
  subscriber_document: string;
  subscription_plan: string;
  transaction_type: FinancialTransactionType;
  payment_method: PaymentMethod;
  payment_month_reference: string;
  charged_at: string;
  price: number;
  status: FinancialStatus;
  card_final_numbers?: string;
  paid_at?: string;
  code?: string;
};

export type FinancialChart = {
  total: number;
};

export type FinancialOrder = {
  id: string;
  created_at: string;
  charged_at: string;
  type: FinancialTransactionType;
  description: string;
  price: number;
  status: FinancialStatus;
  payment_method?: PaymentMethod;
  card_final_numbers?: string;
  paid_at?: string;
  code?: string;
};

export type FinancialCreditCard = {
  id: string;
  brand: CardBrand;
  final_numbers: string;
  is_default: boolean;
};
